import React, { Fragment, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Container, Input, Col, Card, CardBody } from "reactstrap";
import { FaTelegramPlane } from "react-icons/fa";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import GreetingCard from "../../Components/Jobseeker/Dashboard/GreetingCard";
import WidgetsWrapper from "../../Components/Jobseeker/Dashboard/WidgetsWraper";
import TopActiveJobs from "../../Components/Jobseeker/Dashboard/TopActiveJobs";
import Acquisitions from "../../Components/Jobseeker/Dashboard/Acquisitions";
import AppliedJobDataTable from "../../Components/Jobseeker/Dashboard/AppliedJobDataTable";
import NewApplicants from "../../Components/Jobseeker/Dashboard/NewApplicants";
import Carousels from "../../Components/Jobseeker/Dashboard/Carousels";
import { fetchDashboardDataRequest } from "../../redux/jobseeker/dashboard/actions";
import { fetchJobseekerDataRequest } from "../../redux/jobseeker/fetch_Jobseeker_data/actions";
import "react-date-range/dist/styles.css"; // Main style file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
import Congratulations from "../../Components/Jobseeker/Dashboard/Congratulations";
import { DateRange } from "react-date-range";
import { getTotalPointsRequest } from "../../redux/get_total_points/actions";

import { useNavigate } from "react-router-dom";

const DashboardJobseekerPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardData = useSelector((state) => state.jobseekerDashboardReducer.data);
  const [selectedDateRange, setSelectedDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const dateRangePickerRef = useRef(null);
  // Call dispatch inside any event handler or useEffect hook
  useEffect(() => {
    dispatch(fetchDashboardDataRequest());
    dispatch(fetchJobseekerDataRequest());
  }, [dispatch]);

  useEffect(() => {
    // Only redirect if jobseeker just logged in (not on subsequent visits)
    const hasRedirected = localStorage.getItem("jobseeker_resume_redirected");
    if (
      dashboardData &&
      dashboardData.data &&
      dashboardData.data.isResumeUploaded === false &&
      !hasRedirected
    ) {
      localStorage.setItem("jobseeker_resume_redirected", "true");
      navigate("/job/jobseeker/update_profile");
    }
    // Redirect if educationExists is false and not redirected before
    const hasEducationRedirected = localStorage.getItem("jobseeker_education_redirected");
    if (
      dashboardData &&
      dashboardData.data &&
      dashboardData.data.educationExists === false &&
      !hasEducationRedirected
    ) {
      localStorage.setItem("jobseeker_education_redirected", "true");
      navigate("/job/jobseeker/update_profile");
    }
  }, [dashboardData, navigate]);

  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const handleToggleDateRangePicker = () => {
    setIsDateRangePickerOpen(!isDateRangePickerOpen);
  };

  const handleDateRangePickerClose = () => {
    setIsDateRangePickerOpen(false);
  };

  return (
    <Fragment>
      <Breadcrumbs title="Dashboard" mainTitle="Dashboard" />
      <Container fluid={true}>
        <Row className="widget-grid position-relative">
          {/* <Col
            xxl="12"
            lg="12"
            className="box-col-12 d-flex justify-content-end"
          >
            <Input
              className="mb-3 form-control custom-input-width"
              type="text"
              placeholder="Select date range"
              onFocus={handleToggleDateRangePicker}
              readOnly // Prevent typing in the input field
              style={{ width: "150px" }} // Adjust the width as needed
            />
            {isDateRangePickerOpen && (
              <div
                ref={dateRangePickerRef}
                className="position-absolute"
                style={{ zIndex: "9999", top: "38px", right: "0" }}
              >
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => {
                    if (item.selection) {
                      setSelectedDateRange([item.selection]);
                    }
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={selectedDateRange}
                  locale={{
                    ...locale, // Spread the locale object here
                    format: "MM/dd/yyyy",
                    separator: " - ",
                    applyLabel: "Apply",
                    cancelLabel: "Cancel",
                    weekStartsOn: 0,
                  }}
                  onClose={handleDateRangePickerClose}
                />
              </div>
            )}
          </Col> */}
          <Col xl="4" md="12" lg="12">
            <Row>
              <Col xl="12" md="6" lg="6">
                <Congratulations />
              </Col>
              <Col xl="12" md="6" lg="6">
                <GreetingCard />
              </Col>
              {dashboardData && dashboardData.data && !dashboardData.data.telegramSessionExists && (
                <Col xl="12" md="12" lg="12" className="mt-2">
                  <TelegramJoinCard seekerId={dashboardData.data.seeker_id} />
                </Col>
              )}
            </Row>
          </Col>
          <Col xl="8" lg="12" md="12" sm="12" className="">
            <WidgetsWrapper />
          </Col>
          <Col sm="12">
            <Carousels />
          </Col>
          <Col xl="12" lg="12" md="12" sm="12" className="">
            <AppliedJobDataTable />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

const TelegramJoinCard = ({ seekerId }) => {
  const telegramUrl = `https://t.me/jobportal_notifications_bot?start=${seekerId}`;

  return (
    <Card className="o-hidden mb-3" style={{ border: "none" }}>
      <CardBody
        className="balance-widget"
        style={{
          background: "linear-gradient(135deg, #1d3557 0%, #457b9d 100%)",
          borderRadius: "12px",
          position: "relative",
          overflow: "hidden",
          color: "white",
        }}
      >
        <div style={{ position: "relative", zIndex: 2 }}>
          <div className="d-flex align-items-center gap-2 mb-2">
            <FaTelegramPlane size={24} style={{ color: "#0088cc" }} />
            <h4 className="f-w-600 mb-0" style={{ color: "white", fontSize: "1.1rem" }}>
              Join Telegram Notifications
            </h4>
          </div>
          <p className="f-light f-13 mt-2" style={{ color: "rgba(255, 255, 255, 0.9)", lineHeight: "1.5" }}>
            Connect with our Telegram bot to receive instant alerts and updates for jobs matching your profile!
          </p>
          <div className="mt-3">
            <a
              href={telegramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn f-w-500 text-white"
              style={{
                background: "linear-gradient(135deg, #0088cc 0%, #005580 100%)",
                border: "none",
                borderRadius: "20px",
                padding: "8px 20px",
                boxShadow: "0 4px 15px rgba(0, 136, 204, 0.4)",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(0, 136, 204, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "none";
                e.target.style.boxShadow = "0 4px 15px rgba(0, 136, 204, 0.4)";
              }}
            >
              <FaTelegramPlane size={16} />
              Join Bot
            </a>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "-30px",
            right: "-30px",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
            zIndex: 1
          }}
        />
      </CardBody>
    </Card>
  );
};

export default DashboardJobseekerPage;
